module.exports = __webpack_public_path__ + "static/media/star_half.b5fe6b7e.svg";